import React, { createContext, useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { decodeToken } from 'react-jwt';
import { logout } from '../../pages/Login/loginSlice';
import api from '../../utils/api';
import { API_ENDPOINTS } from '../../utils/apiUrls';
import Logo from '../../assets/images/logo.png';
import './AmlWorkspaceLayout.scss';

// AML Check on its own (Ankit, 6 Oct 2026: "a new all-alone model for AML check", first shown
// to Blue Gold). The same AML pages as in Oomero, under /aml, without the main menu: a company
// that only screens names sees nothing else. The pages ask useAmlBasePath() where their own links
// go, so a check opened here stays here.

const AmlBasePathContext = createContext('/aml-check');
export const AML_WORKSPACE_PATH = '/aml';
export const useAmlBasePath = () => useContext(AmlBasePathContext);

function AmlWorkspaceLayout({ children }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = decodeToken(localStorage.getItem('token') || '') || {};
    const displayName = [token.firstName, token.lastName].filter(Boolean).join(' ');
    const company = token.entity_name || token.entityName || token.company_name || '';

    const signOut = async () => {
        try {
            await api.post(API_ENDPOINTS.logoutUser);
        } catch (error) {
            // Signing out here still happens when the server cannot be reached.
        }
        dispatch(logout());
        navigate('/login');
    };

    return (
        <AmlBasePathContext.Provider value={AML_WORKSPACE_PATH}>
            <div className='aml-workspace'>
                <a className='aml-workspace__skip' href='#aml-workspace-main'>Skip to content</a>
                <header className='aml-workspace__bar'>
                    <NavLink to={AML_WORKSPACE_PATH} end className='aml-workspace__brand' aria-label='AML Check home'>
                        <img src={Logo} alt='Oomero' />
                        <span className='aml-workspace__product'>AML Check</span>
                    </NavLink>
                    <nav className='aml-workspace__nav' aria-label='AML Check'>
                        <NavLink to={AML_WORKSPACE_PATH} end>Checks</NavLink>
                        <NavLink to='/'>Open full Oomero</NavLink>
                    </nav>
                    <div className='aml-workspace__account'>
                        {displayName || company ? (
                            <span className='aml-workspace__who'>
                                {displayName}
                                {company ? <small>{company}</small> : null}
                            </span>
                        ) : null}
                        <button type='button' className='aml-workspace__signout' onClick={signOut}>Sign out</button>
                    </div>
                </header>
                <main id='aml-workspace-main' className='aml-workspace__main' tabIndex={-1}>
                    {children}
                </main>
            </div>
        </AmlBasePathContext.Provider>
    );
}

export default AmlWorkspaceLayout;
